import React, { useEffect, useState } from 'react';
import moment from 'moment';
import utils from 'utils';
import { UmbracoStep } from 'components/Umbraco/UmbracoContext';
import { CheckValidInputs, EditField, MainCond, useInput, StepBody, StepFooter, ToggleGroup, DateField, NumericField, LineSmall } from 'meitav-uikit';
import { postData, setDataLayer } from '../../../../../utils/Functions';
import "./step32.scss";
import Footer from 'components/Footer';
import { Parser } from 'html-to-react';
import { isMobile } from "react-device-detect";

const { UmbracoUtills, rest } = utils;

export default function Step32({
  resource,
  model,
  setModel,
  setStep,
  step, nextText,
  resourceError,
  dataList,
  setDataList,
  disable
}) {
  const p = new Parser();
  const today = new Date();
  const oneMonths = new Date();
  oneMonths.setMonth(today.getMonth() + 1);
  const formatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
  const formattedToday = today.toLocaleDateString('en-GB', formatOptions);
  const formattedOneMonthFromToday = oneMonths.toLocaleDateString('en-GB', formatOptions);
  // const today = new Date();
  //const oneMonths = today.setMonth(today.getMonth() + 1);
  const today2 = new Date();

  const twoMonth = today2.setMonth(today2.getMonth() + 2);
  const resourceStep = UmbracoStep(resource, `SecondSub2Step`);

  const myCond = {
    minSum: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorRestrictionMaxSum"),
      cond: (value) => value && (parseInt(value.toString().replace(",","")) < dataList.minDepositSum),
    },
    minDeposit: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorRestrictionMaxSum"),
      cond: (value) => value != '' && (parseInt(value.toString().replace(",","")) < parseInt(depositSum.value.toString().replace(",",""))),
    },
    minDate: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorRestrictionUntillDate"),
      cond: (value) => !checkDate(value),
    }
  };
  const checkDate = (value) => {


    if (value == '')
      return true;
    const date = value.split("/");
    const target = new Date(date[2], date[1] - 1, date[0]);


    return target > oneMonths;

  }
  //const target = new Date(targetDate);

  //const isMoreThanOneMonthAway = target > oneMonthFromToday;
  const [minDeposit, setMinDeposit] = useState(dataList.minDepositSum || 0);
  //const allowDigitalDeposit = model.paymentDetails.isBigBank || false;
  const depositSum = useInput(UmbracoUtills.getValueByKey(resourceStep, 'textSumDeposit'), model.paymentDetails?.depositSum || model.mainUser?.depositSum, [MainCond.empty, myCond.minSum]);
  const depositTypeId = useInput(UmbracoUtills.getValueByKey(resourceStep, 'howToMakeDeposit'), model.paymentDetails?.depositTypeId || 1);
  const [depositSumChange, setDepositSumChange] = useState(false);
  const permitionType = useInput(UmbracoUtills.getValueByKey(resourceStep, 'restrictPermission'), model.paymentDetails?.permitionTypeId != null && model.paymentDetails?.permitionTypeId == 1 ? "1" : "2");
  const restrictionDate = useInput(UmbracoUtills.getValueByKey(resourceStep, 'permisionDateText'));
  const restrictionSum = useInput(UmbracoUtills.getValueByKey(resourceStep, 'permisionSumText'), model.paymentDetails?.restrictionMaxSum || depositSum.value);

  const restrictOptions = [{ text: "כן", value: "2" }, { text: "לא", value: "1" }];
  const depositOptions = [{ text: UmbracoUtills.getValueByKey(resourceStep, "checkBoxDigitalDeposit"), value: 2 }, { text: UmbracoUtills.getValueByKey(resourceStep, "checkBoxBankTransfer"), value: 1 }];


  useEffect(() => {
    if (!dataList.minDepositSum) getMinDeposit();
  }, []);

  useEffect(() => {
    if (minDeposit > 0) {
      depositSum.setConds([MainCond.empty, myCond.minSum]);
    }
  }, [minDeposit]);

  const getMinDeposit = async () => {
    //const t = await rest.get(`/api/DepositAccount/getMinDeposit`);
    setMinDeposit(25000);
    let tmpList = dataList;
    tmpList.minDepositSum = 25000;
    setDataList(tmpList);
    localStorage.setItem('dataList', JSON.stringify(tmpList));

  };
  useEffect(() => {
    if (depositTypeId.value === 2) {

      restrictionDate.setValue(model.paymentDetails.restrictionUntillDate);
    }

  }, [depositTypeId.value]);

  useEffect(() => {
    if (depositTypeId.value === 2) {
      permitionType.setConds([MainCond.empty]);
    } else {
      permitionType.setValue("");
      permitionType.setConds([]);
    }
  }, [depositTypeId.value]);

  useEffect(() => {
    restrictionSum.setConds([]);
    restrictionDate.setConds([]);
    if (permitionType.value == "2") {
      restrictionSum.setConds([myCond.minDeposit]);
      restrictionDate.setConds([myCond.minDate]);
    }

  }, [depositSum.value, permitionType.value]);

  useEffect(() => {
    restrictionSum.validate();
  }, [restrictionSum.conds]);
  useEffect(() => {
    setDepositSumChange(true);
    setDataLayer("PM - bank deposit", window.location.pathname, "הרשאת חיוב חשבון", `${depositSum.value}
   :הקלדת סכום להפקדה {חד פעמית}`)

  }, [depositSum.value != model.paymentDetails.depositSum]);
  //const onChangeSumDeposit =  (e) => {
  //{
  // setDepositSumChange(true);
  //setDataLayer("PM - bank deposit",window.location.pathname ,"הרשאת חיוב חשבון",`${e} :הקלדת סכום להפקדה {חד פעמית}`)}
  //}

  const handleNext = async () => {
    if (disable) {
      if (depositTypeId.value === 2) {
        setStep(33);
      } else {
        setStep(34);
      }
      return;
    }
    if (!CheckValidInputs([depositSum, permitionType])) {
      return;
    }
    if (restrictionSum.value != '' && !CheckValidInputs([restrictionSum])) {
      return;
    } if (restrictionDate.value != '' && !CheckValidInputs([restrictionDate])) {
      return;
    }
    window.dataLayer.push({
      event: "PM - bank deposit",
      eventInfo: {
        action_screen: window.location.pathname,
        user_deposit_value: depositSum,
        process_level: "הרשאת חיוב חשבון",
        action_name: "המשך מוצלח של שלב הרשאה לחיוב חשבון",
        deposit_value_metric: depositSum,
      },
    });

    let tmpModel = model;
    tmpModel.paymentDetails.depositSum = depositSum.value;
    tmpModel.paymentDetails.depositTypeId = depositTypeId.value;
    tmpModel.paymentDetails.depositSumChange = depositSumChange;
    if (depositTypeId.value === 2) {
      tmpModel.paymentDetails.permitionTypeId = permitionType.value;
      tmpModel.paymentDetails.restrictionUntillDate = restrictionDate.value;
      tmpModel.paymentDetails.restrictionMaxSum = restrictionSum.value;
    } else {
      tmpModel.paymentDetails.permitionTypeId = "";
      tmpModel.paymentDetails.restrictionUntillDate = "";
      tmpModel.paymentDetails.restrictionMaxSum = "";
      tmpModel.paymentDetails.signature = "";
    }
    tmpModel.currentStepID = 32;

    if (depositTypeId.value == "2") {
      tmpModel.stepID = 33;
    }

    else {
      tmpModel.stepID = 34;
    }
    postData(tmpModel, setStep);
  };

  const handlePrev = async () => {
    setDataLayer("PM - Levels", "/JoinPersonalDetails", "חזור לשלב הקודם", "חזרה - " + step);

    let tmpModel = model;
    tmpModel.paymentDetails.depositSum = depositSum.value;
    tmpModel.paymentDetails.depositTypeId = depositTypeId.value;
    tmpModel.paymentDetails.depositSumChange = depositSumChange;

    if (depositTypeId.value == "2") {
      tmpModel.paymentDetails.permitionTypeId = permitionType.value;
      tmpModel.paymentDetails.restrictionUntillDate = restrictionDate.value;
      tmpModel.paymentDetails.restrictionMaxSum = restrictionSum.value;
    } else {
      tmpModel.paymentDetails.permitionTypeId = "";
      tmpModel.paymentDetails.restrictionUntillDate = "";
      tmpModel.paymentDetails.restrictionMaxSum = "";
      tmpModel.paymentDetails.signature = "";
    }
    setModel(tmpModel);
    setStep(31);
  };

  return (
    <div className="step32">
      <StepBody>
        <EditField id="depositSum" disable={disable}{...depositSum} type="numeric" prefix='₪'
        />
        <ToggleGroup id="depositTypeId" disable={disable} {...depositTypeId} options={depositOptions} align="center" />
        {depositTypeId.value == "2" ?
          <>
            <ToggleGroup id="permitionType" disable={disable}{...permitionType} options={restrictOptions} direction={`${!isMobile ? 'horizontal' : ''}`} />
            {permitionType.value == '2' ?
              <>
              <LineSmall>
                <DateField id="restrictionDate" disable={disable} {...restrictionDate} />
                <NumericField id="restrictionSum" disable={disable} {...restrictionSum} /></LineSmall>
              </>
              : null}
          </>
          : null}
      </StepBody>
      <StepFooter nextText={nextText}
        handleNext={handleNext} handlePrev={handlePrev} />
      <Footer text={p.parse(UmbracoUtills.getValueByKey(
        resourceStep,
        "mainText"
      ))}></Footer>
    </div>
  );
}
